import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs/operators';

import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import {
  CommonPaginationResponse,
  CommonResponse,
  PaginateResponse,
  processNormal, processPagination,
  VoidResponse
} from '../common/response.model';
import { ErrorHandlingService } from '../common/error-handling.service';
import { Doctor, DoctorStatus } from './doctor.model';
import { MedicalSpeciality } from '../medical-specialities/medical-speciality.model';
import { Observable } from 'rxjs';
import { DoctorForm } from '../../FormModels/doctor-form.model';
import { getFullPhoneNumber, getPhoneNumberCountry } from '../../helpers/phone_number.helper';

@Injectable()
export class DoctorService {

  constructor(private http: HttpClient, private errorHandling: ErrorHandlingService) {
  }

  register(login_type: string, doctor: DoctorForm, signature: string, student: string,): Observable<Doctor> {
    console.log(doctor);
    console.log("estudiante ", student);
    const bodyParams = {
      name: doctor.name,
      last_name: doctor.last_name,
      email: doctor.email,
      phone_number: getFullPhoneNumber(doctor.phone_number_ui),
      phone_number_country: getPhoneNumberCountry(doctor.phone_number_ui),
      password: doctor.password,
      password_confirmation: doctor.password_confirmation,
      user_type: 'individual',
      identity_document: doctor.identity_document,
      professional_registry: doctor.professional_registry,
      student: student == "si" ? 1 : 0,
      signature: signature
    };


    return this.http.post<CommonResponse<Doctor>>(
      environment.apiUrl + 'register/doctor',
      bodyParams
    ).pipe(
      map(resp => processNormal(resp)),
      catchError(this.errorHandling.handleErrors)
    );
  }


  getOwnSpecialities(): Observable<MedicalSpeciality[]> {
    return this.http.get<CommonResponse<MedicalSpeciality[]>>(
      environment.apiUrl + 'doctor/my-specialities'
    ).pipe(
      map(resp => processNormal(resp)),
      catchError(this.errorHandling.handleErrors)
    );
  }

  addSpeciality(speciality: MedicalSpeciality): Observable<MedicalSpeciality> {

    return this.http.post<CommonResponse<MedicalSpeciality>>(
      environment.apiUrl + 'doctor/my-specialities',
      {
        speciality: speciality.id
      }
    ).pipe(
      map(resp => processNormal(resp)),
      catchError(this.errorHandling.handleErrors)
    );
  }

  editSpeciality(speciality: MedicalSpeciality): Observable<MedicalSpeciality> {

    return this.http.put<CommonResponse<MedicalSpeciality>>(
      environment.apiUrl + 'doctor/my-specialities/' + speciality.id,
      {
      }
    ).pipe(
      map(resp => processNormal(resp)),
      catchError(this.errorHandling.handleErrors)
    );
  }

  deleteSpeciality(speciality: MedicalSpeciality): Observable<MedicalSpeciality> {

    return this.http.delete<CommonResponse<MedicalSpeciality>>(
      environment.apiUrl + 'doctor/my-specialities/' + speciality.id
    ).pipe(
      map(resp => processNormal(resp)),
      catchError(this.errorHandling.handleErrors)
    );
  }

  // ABM de doctores

  /**
   * Obtener el listado de todos los doctores sin paginacion
   *
   * @return Observable<Doctor[]>
   */
  public listAll(filter = '', allVerified = false): Observable<Doctor[]> {

    let params = new HttpParams().append('no-paginate', '1');
    if (filter !== '') { params = params.append('filter', filter); }

    const url = allVerified ? '/search' : '';

    return this.http.get<CommonResponse<Doctor[]>>(
      environment.apiUrl + 'doctors' + url,
      {
        params
      }
    ).pipe(
      map(resp => processNormal(resp)),
      catchError(this.errorHandling.handleErrors)
    );
  }

  /**
   * Obtener el listado de todos los doctores con paginacion
   *
   * @return Observable<PaginateResponse<Doctor[]>>
   */
  public listPaginated(page, per_page, filter = ''): Observable<PaginateResponse<Doctor[]>> {
    let params = new HttpParams().append('paginate_per_page', per_page.toString()).append('page', page);
    if (filter !== '') { params = params.append('filter', filter); }

    return this.http.get<CommonPaginationResponse<Doctor[]>>(
      environment.apiUrl + 'doctors',
      {
        params
      }
    ).pipe(
      map(resp => processPagination(resp)),
      catchError(this.errorHandling.handleErrors)
    );
  }

  /**
   * Agregar un doctor a la plataforma
   *
   * @return Observable<Doctor>
   */
  public add(doctor: DoctorForm): Observable<Doctor> {

    const bodyParams = {
      account: doctor.account.toString(),
      name: doctor.name,
      last_name: doctor.last_name,
      professional_registry: doctor.professional_registry.toString(),
      identity_document: doctor.identity_document.toString(),
    };

    if (doctor.status !== '') {
      bodyParams['status'] = doctor.status;
    }

    if (doctor.assistants.length > 0) {
      bodyParams['assistants'] = doctor.assistants;
    }

    if (doctor.phone_number !== undefined) {
      bodyParams['phone_number'] = doctor.phone_number;
    } else if (doctor.email !== undefined) {
      bodyParams['email'] = doctor.email;
    }


    return this.http.post<CommonResponse<Doctor>>(
      environment.apiUrl + 'doctors',
      bodyParams
    ).pipe(
      map(resp => processNormal(resp)),
      catchError(this.errorHandling.handleErrors)
    );
  }

  /**
   * Ver datos de un doctor
   *
   * @return Observable<Doctor>
   */
  public show(id: string, verified: boolean = false): Observable<Doctor> {

    let params = new HttpParams();
    if (verified) { params = params.append('public', 'true'); }

    return this.http.get<CommonResponse<Doctor>>(
      environment.apiUrl + 'doctors/' + id,
      {
        params
      }
    ).pipe(
      map(resp => processNormal(resp)),
      catchError(this.errorHandling.handleErrors)
    );
  }

  /**
   * Editar datos del doctor
   *
   * @return Observable<Doctor>
   */
  public edit(id: string, doctor: any): Observable<Doctor> {
    // ✅ Ahora aceptamos 'any' para recibir el payload completo que construimos en el componente

    const bodyParams: any = {
      assistants: doctor.assistants || []
    };

    if (doctor.status !== undefined && doctor.status !== null && doctor.status !== '') {
      bodyParams['status'] = doctor.status;
    }

    // ✅ AGREGADO: professional_registry
    if (doctor.professional_registry !== undefined && doctor.professional_registry !== null) {
      bodyParams['professional_registry'] = doctor.professional_registry;
    }

    if (doctor.user_fundacion_paraguaya !== undefined && doctor.user_fundacion_paraguaya !== null) {
      bodyParams['user_fundacion_paraguaya'] = doctor.user_fundacion_paraguaya;
    }

    // ✅ AGREGADO: bill_doctor
    if (doctor.bill_doctor !== undefined && doctor.bill_doctor !== null) {
      bodyParams['bill_doctor'] = doctor.bill_doctor;
    }

    if (doctor.consultation_price !== undefined) {
      bodyParams['consultation_price'] = doctor.consultation_price;
    }

    if (doctor.consultation_standard_duration !== null) {
      bodyParams['consultation_standard_duration'] = doctor.consultation_standard_duration;
    }

    return this.http.put<CommonResponse<Doctor>>(
      environment.apiUrl + 'doctors/' + id,
      bodyParams
    ).pipe(
      map(resp => processNormal(resp)),
      catchError(this.errorHandling.handleErrors)
    );
  }

  /**
   * Eliminar el doctor
   *
   * @return Observable<VoidResponse>
   */
  public delete(id: number, type: string = 'drop'): Observable<VoidResponse> {

    return this.http.delete<CommonResponse<VoidResponse>>(
      environment.apiUrl + 'doctors/' + id,
      {
        params: new HttpParams().append('type', type)
      }
    ).pipe(
      map(resp => processNormal(resp)),
      catchError(this.errorHandling.handleErrors)
    );
  }


  /**
   * Posibles estados del doctor
   *
   * @return Observable<DoctorStatus[]>
   */
  public statuses(): Observable<DoctorStatus[]> {

    return this.http.get<CommonResponse<DoctorStatus[]>>(
      environment.apiUrl + 'doctors/statuses',
      {
        params: new HttpParams().append('no-paginate', '1')
      }
    ).pipe(
      map(resp => processNormal(resp)),
      catchError(this.errorHandling.handleErrors)
    );
  }


  /**
   * Ping de actividad del doctor
   *
   * @return Observable<void>
   */
  public pingActivity(): Observable<void> {

    return this.http.get<void>(
      environment.apiUrl + 'ping/doctor'
    ).pipe(
      catchError(this.errorHandling.handleErrors)
    );
  }

}
